<template>
	<div class="md-grey-page center-horizontal">
		<section class="container-white">
			<img src="/static/img/logo_circle.png" width="100" />
			<p>
				Hello {{portal}},
			</p>
			<p>
				Thank you for requesting the activation of the property data feed from {{companyName}} using Branch IDs {{branchIds}}.
			</p>
			<p>
				By clicking the button below, you will immediately trigger the initial upload of all properties and images via BestAgent.
			</p>
			<p>
				Please note, all subsequent property changes will be sent in real time.
			</p>
			<button id="activatePortal" class="mdc-button mdc-button--raised" @click.prevent="activatePortal" :disabled="sending">{{btnText}}</button>
		</section>
	</div>
</template>

<script>
import axios from 'axios';

export default {
  data: function() {
    return {
		companyName: '',
		branchIds: '',
		statusText: '',
		sending: false
    }
  },
  created: async function() {
	  if(this.$route.params.portal !== 'rightmove' && this.$route.params.portal !== 'zoopla' && this.$route.params.portal !== 'onthemarket') {
		  this.$router.push('/');
	  }
	  try {
		  const companyBranches = await axios.get(this.config.services.portals + '/' + this.portalId + '/branches/' + this.$route.params.id);
		  this.companyName = companyBranches.data.companyName;
		  if(companyBranches.data.branches.sales) {
			  this.branchIds += companyBranches.data.branches.sales;
		  }
		  if(companyBranches.data.branches.lettings) {
			  if(this.branchIds != '') {
				  this.branchIds += ' and ';
			  }
			  this.branchIds += companyBranches.data.branches.lettings;
		  }
	  } catch(err) {
		  console.log('Error:', err);
		  throw {
			  type: 'activate-portal-get-branches',
			  error: err
		  }
	  }
  },
  computed: {
	  btnText: function() {
		  if(!this.sending) {
			  return 'Activate upload of properties from ' + this.companyName + ' via BestAgent';
		  } else {
			  return this.statusText;
		  }
	  },
	  portalId: function() {
      if(this.$route.params.portal === 'rightmove') {
			  return 'rm';
		  }
      if(this.$route.params.portal === 'onthemarket') {
			  return 'otm';
		  }
		  if(this.$route.params.portal === 'zoopla') {
			  return 'zoopla';
		  }
		  return '--';
	  },
	  portal: function() {
      if(this.$route.params.portal === 'rightmove') {
			  return 'Rightmove';
		  }
      if(this.$route.params.portal === 'onthemarket') {
			  return 'OnTheMarket';
		  }
		  if(this.$route.params.portal === 'zoopla') {
			  return 'Zoopla';
		  }
		  return '--';
	  }
  },
  methods: {
	  activatePortal() {
		  const that = this;
		  this.sending = true;
		  this.statusText = 'Activating real-time ' + this.portal + ' feed for ' + this.companyName + '...';

		  axios.patch(this.config.services.portals + '/' + this.portalId + '/activate/' + this.$route.params.id)
		  .then(function(response) {
			  that.statusText = 'Activation successful!';
		  })
		  .catch(function(error) {
			  that.statusText = 'Sorry, something went wrong... Can you contact us please at support@bestagent.online!';
			  throw {
				  type: 'activating-portal',
				  error: error
			  }
		  });
	  }
  }
}
</script>

<style>
	#activatePortal.mdc-button {
		height: auto;
		line-height: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ActivatePortal.vue